import React, { useContext } from 'react';
import { makeStyles, IconButton } from '@material-ui/core';
import CallIcon from '@material-ui/icons/Call';
import VideocamIcon from '@material-ui/icons/Videocam';
import UserWithStatus from './UserWithStatus';
import ScrollToBottom from 'react-scroll-to-bottom';
import FlipMove from 'react-flip-move';
import Message from './Message';
import { MessagesContext } from '../context/MessagesContext';
import { UsersContext } from '../context/UsersContext';

const useStyles = makeStyles({
  messenger_container: {
    gridArea: 'm',
    background: '#f3f3f3',
    overflowY: 'auto',
  },
  currentReceiver_container: {
    gridArea: 'c',
    borderBottom: '1px solid #ddd',
    display: 'flex',
    alignItems: 'center',
    padding: '0 20px',
  },
  messages_container: {
    height: '100%',
    boxSizing: 'border-box',
  },
});

export default function Messenger() {
  const [messages] = useContext(MessagesContext);
  const { selectedUser: _selectedUser } = useContext(UsersContext);
  const [selectedUser] = _selectedUser;

  const classes = useStyles();

  return (
    <>
      <div className={classes.currentReceiver_container}>
        {selectedUser.uid && (
          <>
            <UserWithStatus
              name={selectedUser.username}
              color={selectedUser.color}
              status='Online'
            />
            <div style={{ marginLeft: 'auto' }}>
              <IconButton>
                <CallIcon />
              </IconButton>
              <IconButton>
                <VideocamIcon />
              </IconButton>
            </div>
          </>
        )}
      </div>
      <div className={classes.messenger_container}>
        {messages ? (
          <ScrollToBottom className={classes.messages_container}>
            <FlipMove>
              {messages.map(({ text, id, senderId, timestamp }) => (
                <Message
                  text={text}
                  senderId={senderId}
                  key={id}
                  timestamp={timestamp}
                />
              ))}
            </FlipMove>
          </ScrollToBottom>
        ) : (
          'Chatty'
        )}
      </div>
    </>
  );
}
